/**
 * Only avatar images from hosts we trust are ever rendered. An agent avatar arrives in a payload
 * from outside our systems; hotlinking an arbitrary host would let it track the customer (the
 * request leaks their IP and that they opened the chat) or serve something unexpected. The
 * server applies the same allowlist; this is the second check, at the point of rendering.
 */
const ALLOWED_AVATAR_HOST_SUFFIXES = ['gravatar.com', 'zendesk.com', 'zdusercontent.com'];
export function safeAvatarUrl(raw) {
    if (!raw)
        return null;
    let url;
    try {
        url = new URL(raw);
    }
    catch (_a) {
        return null;
    }
    if (url.protocol !== 'https:')
        return null;
    // `https://gravatar.com@evil.example/` has the host evil.example: reject any credentials outright.
    if (url.username || url.password)
        return null;
    const host = url.hostname.toLowerCase();
    const allowed = ALLOWED_AVATAR_HOST_SUFFIXES.some((suffix) => host === suffix || host.endsWith(`.${suffix}`));
    return allowed ? url.toString() : null;
}
